const axios = require("axios");
const utils = require("@/libs/utils");
const router = require("@/libs/router");

// axios 配置
const axiosInstance = axios.create({
  baseURL: process.env.MBFF_HOST,
  // baseURL: "https://srv-qa.app.ikea.cn",
  timeout: 10000,
  withCredentials: false
})

// http request 拦截器
axiosInstance.interceptors.request.use(
  config => {
    config.headers['Accept-Language'] = 'zh-cn'
    config.headers['X-Client-Version'] = utils.getClientVersion()
    config.headers['X-Client-Platform'] = utils.getClientPlatform()
    config.headers['X-Client-DeviceModel'] = utils.getDeviceId()
    config.headers['X-Client-DeviceId'] = utils.getDeviceId()
    config.headers['X-Client-OSVersion'] = ''
    config.headers['X-Client-Personalized'] = utils.getPersonalized()
    config.headers['Source'] = 'SHOPPABLE_APP'
    return config
  },
  err => {
    console.log(err)
    return Promise.reject(err)
  },
)

axiosInstance.interceptors.response.use(response => {
  return response
}, error => {
  console.log(error)
  // 统一处理401
  if (error && error.response && error.response.status === 401) {
    router.open("login")
  }
  return Promise.reject(error);
})

export default {
  get(url, options = {}) {
    return new Promise((resolve, reject) => {
      if (options.needToken) {
        utils.getToken(token => {
          axiosInstance.get(url, {
            headers: { Authorization: token}
          }).then(resolve).catch(reject)
        })
      } else {
        axiosInstance.get(url).then(resolve).catch(reject)
      }
    })
  },
  post(url, params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      if (options.needToken) {
        utils.getToken(token => {
          axiosInstance.post(url, params, {
            headers: { Authorization: token}
          }).then(resolve).catch(reject)
        })
      } else {
        axiosInstance.post(url, params).then(resolve).catch(reject)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/libs/mbff.js